import "./agreeTermsCheckbox.scss";
import PropTypes from "prop-types";

const AgreeTermsCheckbox = ({ id, checked, onChange, children, error }) => {
  return (
    <div className="checkbox-inline">
      <label htmlFor={id}>
        <input id={id} type="checkbox" checked={checked} onChange={onChange} />
        {children}
      </label>
      {error && <p className="error">{error}</p>}
    </div>
  );
};


AgreeTermsCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  error: PropTypes.string,
};

export default AgreeTermsCheckbox;


